// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpInsistWindowChangeOpinion extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.insist_window.change_opinion";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpInsistWindowChangeOpinion {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "He canviat d'opinió i accepte",
                "cs": "Změnil jsem názor a souhlasím",
                "da": "Jeg har ændret mening og accepterer",
                "de": "Ich habe meine Meinung geändert und akzeptiere",
                "en": "I have changed my mind and I accept",
                "es": "He cambiado de opinión y acepto",
                "eu": "Iritzia aldatu eta onartu dut",
                "fi": "Olen muuttanut mieleni ja hyväksyn",
                "fr": "J'ai changé d'avis et j'accepte",
                "gl": "Cambiei de opinión e acepto",
                "hi": "मैंने अपना मन बदल लिया है और मैं स्वीकार करता हूं",
                "hu": "Meggondoltam magam és elfogadom",
                "it": "Ho cambiato idea ed accetto",
                "nl": "Ik ben van mening veranderd en accepteer het",
                "no": "Jeg har ombestemt meg og godtar dette",
                "pl": "Zmieniłem zdanie i akceptuję",
                "pt": "Mudei de ideias e aceito",
                "pt-BR": "Eu mudei de ideia e aceito",
                "ro": "M-am răzgândit și accept",
                "ru": "Изменил мнение и  принимаю",
                "sk": "Rozmyslel som si to a súhlasím",
                "sv": "Jag har ändrat mig och accepterar",
                "tr": "Fikrimi değiştirdim ve kabul ediyorum."
            },
            "defecto": "I have changed my mind and accept"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
